var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { UserApi } from "../../../../core/api/userApi";
import isActionAllowed from "../../../../core/authorization/userPermissions";
import { DASHBOARD_VIEWER, USER_VIEW, } from "../../../../core/constants/permissionConstants";
import UnAuthorized from "../../../global/sessions/401";
const PDFViewerPage = () => {
    const { docId } = useParams();
    const [pdfBlobUrl, setPdfBlobUrl] = useState("");
    useEffect(() => {
        const fetchPdf = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const response = yield UserApi.getUserManual(docId);
                if (!response.ok) {
                    console.log("Failed to load PDF");
                    return;
                }
                const blob = yield response.blob();
                const url = URL.createObjectURL(blob);
                setPdfBlobUrl(url);
            }
            catch (err) {
                console.error("Error fetching PDF", err);
            }
        });
        fetchPdf();
        return () => {
            if (pdfBlobUrl)
                URL.revokeObjectURL(pdfBlobUrl);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [docId]);
    if ((docId === "user" && !isActionAllowed([DASHBOARD_VIEWER])) ||
        (docId === "admin" && !isActionAllowed([USER_VIEW])))
        return React.createElement(UnAuthorized, { subText: "permission" });
    return (React.createElement("iframe", { src: pdfBlobUrl, title: `PDF ${docId}`, onError: () => console.error("PDF failed to load"), width: "100%", height: "100%", style: { border: "none", minHeight: "92vh" } }));
};
export default PDFViewerPage;
